import { EventBus } from "./eventBus";
import { FilterControls } from "./filterControls";
import { FilteringHandler } from "./filteringHandler";
import { ReviewSorter } from "./reviewSorting";
class OurReviewsInitializer {
    constructor() {
        this._eventBus = new EventBus();
        window.sortReviews = new ReviewSorter().sortReviews;
        window.filterControls = new FilterControls(this._eventBus);
        window.filteringHandler = new FilteringHandler(this._eventBus);
    }
}
window.DoUtility.SelfInstantiateOnLoad(OurReviewsInitializer);
